// LP（広告運用 無料診断）専用エントリ
// 本体サイト（app.js）とは独立。本体の _modules は参照せず、_lp 配下のコピーを使う。

import LpSmoothScroll from './_lp/LpSmoothScroll.js';
import LpBg from './_lp/LpBg.js';
import LpMarquee from './_lp/LpMarquee.js';
import LpReveal from './_lp/LpReveal.js';
import LpSlideFade from './_lp/LpSlideFade.js';
import LpTableHint from './_lp/LpTableHint.js';
import LpToggleMore from './_lp/LpToggleMore.js';
import LpFlowProgress from './_lp/LpFlowProgress.js';
import LpAccordion from './_lp/LpAccordion.js';
import LpFixedCta from './_lp/LpFixedCta.js';

class Lp {
  constructor() {
    this.modules = [];
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupModules());
    } else {
      this.setupModules();
    }
  }

  setupModules() {
    // 慣性スクロールはページ全体に掛かるので最初に立てる
    this.modules.push(new LpSmoothScroll());

    document.querySelectorAll('.js-lp-bg').forEach((bg) => {
      this.modules.push(new LpBg(bg));
    });

    document.querySelectorAll('.js-lp-marquee').forEach((marquee) => {
      this.modules.push(new LpMarquee(marquee));
    });

    document.querySelectorAll('.js-lp-more').forEach((more) => {
      this.modules.push(new LpToggleMore(more));
    });

    document.querySelectorAll('.js-lp-slide-fade').forEach((slider) => {
      this.modules.push(new LpSlideFade(slider));
    });

    document.querySelectorAll('.js-lp-table-hint').forEach((wrap) => {
      this.modules.push(new LpTableHint(wrap));
    });

    document.querySelectorAll('.js-lp-accordion').forEach((ac) => {
      this.modules.push(new LpAccordion(ac));
    });

    document.querySelectorAll('.js-lp-flow').forEach((flow) => {
      this.modules.push(new LpFlowProgress(flow));
    });

    document.querySelectorAll('.js-lp-fixed-cta').forEach((cta) => {
      this.modules.push(new LpFixedCta(cta));
    });

    this.modules.push(new LpReveal());
  }
}

new Lp();
